export default __webpack_public_path__ + "static/play-92ded8387f7885b7a552d214cf7bca52.png";